import ControlRoomLayout from '../../components/layout/ControlRoomLayout';
import { AnnouncementsManager } from '../../components/AnnouncementsManager';

// Reuses the EXACT admin announcements system (same records, same
// acknowledgement flow). Delete stays Primary-Admin-only (crMode hides it;
// the backend blocks it regardless).
export default function CrAnnouncementsPage() {
  return (
    <ControlRoomLayout>
      <AnnouncementsManager crMode />
    </ControlRoomLayout>
  );
}
